import ApiService from "@/api.service";
import API from "@/API";

export const GET_LIST_PARTNER = "GET_LIST_PARTNER";
export const GET_DETAIL_PARTNER = "GET_DETAIL_PARTNER";
export const UPDATE_PARTNER = "UPDATE_PARTNER";
export const SAVE_PARTNER = "SAVE_PARTNER";
export const DELETE_PARTNER = "DELETE_PARTNER";
export const SET_LIST_PARTNER = "SET_LIST_PARTNER";
export const SET_DETAIL_PARTNER = "SET_DETAIL_PARTNER";



const state = {
    partner: [],
    partnerDetail: {}
};

const getters = {
    partner(state) {
        return state.partner;
    },
    partnerDetail(state) {
        return state.partnerDetail;
    },
};

const actions = {
    [GET_LIST_PARTNER](context) {
        return new Promise(resolve => {
            ApiService.query(`${API.GET_LIST_PARTNER}`).then(({data}) => {
                if (data.status) {
                    context.commit(SET_LIST_PARTNER, data);
                }
                resolve(data);
            });
        });
    },
    [GET_DETAIL_PARTNER](context,id) {
        return new Promise(resolve => {
            ApiService.query(`${API.GET_DETAIL_PARTNER}/${id}`).then(({data}) => {
                if (data.status) {
                    context.commit(SET_DETAIL_PARTNER, data);
                }
                resolve(data);
            });
        });
    },
    [SAVE_PARTNER](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`${API.SAVE_PARTNER}`, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    [UPDATE_PARTNER](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.update(`${API.UPDATE_PARTNER}`, payload.id, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    [DELETE_PARTNER](context, id) {
        return new Promise((resolve, reject) => {
            ApiService.delete(`${API.DELETE_PARTNER}`,id)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },

};

const mutations = {
    [SET_LIST_PARTNER](state, data) {
        state.partner = data.data;
    },
    [SET_DETAIL_PARTNER](state, data) {
        state.partnerDetail = data.data;
    },


};

export default {
    state,
    actions,
    mutations,
    getters
};